import { CnFilterPro, CnButton } from '@alife/cn-ui';
import omit from 'lodash/omit'

const pluginPropsKeyPrefix = "_self_filter_log_"

/**
 * 源码组件插件代码
 * @param props
 * @param context
 */
export const SourceCode = (props, context) => {
  // const [version, setVersion] = useState('oneSearch');
  return {
    props: {
      ...props,
    },
    context,
    // render方法用于渲染插件，render方法中不能使用外层的props变量，需要使用innerProps
    render(innerProps, BaseComponent) {
      return ( 
        <BaseComponent 
          {..._.omit(innerProps, [`${pluginPropsKeyPrefix}searchApi`])} 
          onSearch={(v, ...args) => {
            let api = innerProps[`${pluginPropsKeyPrefix}searchApi`]
            if (typeof api === 'function') {
              try {
                api = api()
              } catch (e) {
                console.error('cnFilterLog get api error =>', e)
              }
            }
            if (api) {
              try {
                const nameMap = {}
                const properties = innerProps?.schema?.properties || {}
                const allFields = Object.keys(properties).map(i => {
                  if (!nameMap[i]) nameMap[i] = properties[i] 
                  return {
                    key: i,
                    label: properties[i].title
                  }
                });
                
                if (!window.trace || !window.trace.reportFilter) return 
                // coneArms API 芷砚那个埋点  采集后直接有报表
                window.trace.reportFilter({
                  // 全量的查询字段配置
                  allFields,
                  // 用户查询内容及查询值
                  filterFields: Object.keys(v || {}).map(i => {
                    return {
                      key: i,
                      label: nameMap[i]?.title,
                      value: v[i]
                    }
                  }),
                  // 列表请求接口
                  api
                });
              } catch (e) {
                console.error('cnFilterLog log error =>', e)
              }
            }
            
            innerProps.onSearch(v, ...args)
          }}
        />
      );
    },
  };
};

/**
 * 低码组件配置项扩展部分
 */
export const LowCode = {
  getPrototypeList: () => {
    return [
      {
        name:'doc',
        title:'使用方法',
        display:'inline',
        setter: () => {
          return <div className="">
            <CnButton
              style={{width:'100%'}}
              onClick={()=>{
                window.open('https://alidocs.dingtalk.com/i/nodes/AR4GpnMqJzKpOoklFAbbL90a8Ke0xjE3')
            }
            }
            >{'查看文档'}</CnButton>
          </div>;
        }
      },
    ].map((item) => {
      return {
        ...item,
        name: `${pluginPropsKeyPrefix}${item.name}`,
      };
    })
  },
};

/**
 * 一码多端插件代码
 * @param props
 * @param context
 */
export const OneCode = (props, context) => {
  return {
    props,
    context,
  };
};
